import React from "react";
import { EmptyState, Button, Flex } from "@jsq/ds/core";
import { useLocation } from "react-router-dom";

const DuplicateSession = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = React.useState(false);
  const retryUrl = new URLSearchParams(location.search).get("initiation_url");
  const description = retryUrl
    ? "By clicking “Yes” any prior preview sessions will be terminated, allowing you to proceed with previewing this contact’s portal. If you would not like to end your prior preview session, please click “Back” to return to your workspace."
    : "Please click “Return to your account” on the initial contact preview before retrying.";

  return (
    <div>
      <div className="stacked-bottom-lg">
        <EmptyState
          illustration="document-failure"
          description={description}
          title="You can only preview one contact at a time"
        >
          <Flex gap={10}>
            {retryUrl && (
              <Button
                isLoading={isLoading}
                data-cy="portal-empty-state-yes-button"
                onClick={() => {
                  setIsLoading(true);
                  // First unspoof to clear the current session, then redirect to retry URL
                  window.location.href = `/unspoof?retry_url=${encodeURIComponent(retryUrl)}`;
                }}
              >
                Yes, end session and continue
              </Button>
            )}
            <Button variant="dangerSecondary" onClick={() => history.back()}>
              Back
            </Button>
          </Flex>
        </EmptyState>
      </div>
    </div>
  );
};

export default DuplicateSession;
